import React, { useState,useEffect} from "react";
import Container from './Container';
import '../styles/OurServicesAndSolutions.css';
import ContactForm from "./ContactForm"; // ⬅ Import new component
import { Helmet ,HelmetProvider} from "react-helmet-async";

const OurServicesAndSolutions = () => {
  const [showForm, setShowForm] = useState(false);
    useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          }
        });
      },
      { threshold: 0.2 } // triggers when 20% visible
    );

    document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);
  return (
  <>
  <HelmetProvider>
    <Helmet>
  <meta
    name="description"
    content="Discover INBI NextGen Innovations' services – custom software, IoT device integration, ERP systems, RFID & biometric applications, and industry-specific solutions."
  />
  <meta name="keywords" content="custom software development, IoT solutions, ERP systems, RFID biometric integration, INBI services" />

  {/* Open Graph */}
  <meta property="og:title" content=" INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta property="og:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today."/>
  <meta property="og:image" content="/assets/Logoblue.jpg" />
  <meta property="og:url" content="https://inbinextgen.com/#services" />
  <meta property="og:type" content="website" />

  {/* Twitter */}
  
  <meta name="twitter:title" content=" INBI NextGen Innovations – Custom Software, IoT & ERP Solutions in India"/>
  <meta name="twitter:description" content="INBI NextGen Innovations builds future-ready software, IoT, and ERP solutions tailored to your business needs. Over 27 
years of expertise. Contact us today."/>
  <meta name="twitter:image" content="/assets/Logoblue.jpg"/>
</Helmet>
  </HelmetProvider>
  
    <section id="services" className="software-solutions-section fade-in">
      <Container className="software-solutions-container fade-in">
        <div className="software-solutions-text">
          <h2> Our Services and Solutions</h2>
          <h3>Custom Software Solutions </h3>
          <p>
            We design software around <b>your exact needs,</b> ensuring clarity, speed, and precision by 
            working directly with decision-makers. Direct collaboration with our project leads ensures clear 
            communication, faster delivery, and zero guesswork. 
          </p>

          <h3>Our expertise includes:</h3>
          <ul>
            <li>Embedded Device Applications</li>
            <li>IoT Device Integration</li>
            <li>RFID & Biometric Software</li>
            <li>ERP Systems for multiple industries</li>
            <li>Hardware-Software Integrated Platforms</li>
          </ul>

          {/* CTA Button */}
         
          <button className="cta-btn" onClick={() => setShowForm(true)}>
            Request a Consultation
          </button>
        </div>

        <div className="software-solutions-image">
          <img src="/assets/interface.svg" alt=" Our Services and Solutions " />
        </div>
      </Container>
      {/* Modal Form Component */}
      {showForm && <ContactForm onClose={() => setShowForm(false)} />}
    </section>
    </> 
  );
};

export default OurServicesAndSolutions;
